import PropTypes from "prop-types"
import React, { useEffect, useState, useMemo, useCallback, useRef } from "react"

import { Link, useNavigate, useParams } from "react-router-dom"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import TableContainer from "../../components/Common/TableContainer2"
import { withTranslation } from "react-i18next"

import { get, put, del } from "helpers/api_helper"
import { checkScope } from "helpers/utility_helper"
import "../../components/Common/datatables.scss"
import Spinners from "components/Common/Spinner"
import moment from "moment"
// import ConsentModal from "components/Common/ConsentModal";

//redux
import { ExportJsonToExcelAPI } from "components/ExportJsonToExcelAPI"
import MyTooltip from "components/MyTooltip"
import useInterviewStore from "../../zustand/store/InterviewDialogModule"
import { format } from "date-fns"
import { DownLoadFile } from "components/DownloadFile"

const InterviewList = props => {
  const interviews = useInterviewStore(state => state.interviews)
  const deleteInterview = useInterviewStore(state => state.deleteInterview)

  // const LANG_CODE_OPTION = [
  //   { id: "en-US", name: "EN" },
  //   { id: "th-TH", name: "TH" },
  //   { id: "ja-JP", name: "JP" },
  //   { id: "vi-VN", name: "VT" },
  //   { id: "zh-TW", name: "CN" },
  //   { id: "zh-CN", name: "CN SIMPLIFIED" },
  // ]

  const deleteRow = useCallback(
    id => () => {
      if (confirm("Are you sure?") == true) {
        const delContent = async () => {
          const result = await del(
            process.env.REACT_APP_BACKEND_URL +
              "/v1/admin/interview-dialog/" +
              id +
              "/delete"
          )
          console.log(result)
          if (result.status === 200) {
            setContentListLoading(true)
            window.location.reload()
          }
        }
        delContent()
      }
    },
    []
  )

  const columns = useMemo(() => [
    {
      header: "#",
      enableColumnFilter: false,
      enableSorting: true,
      cell: cellProps => {
        return (
          <>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {parseInt(cellProps.row.id) + 1}
            </div>
          </>
        )
      },
    },
    {
      header: "Interview Name",
      accessorKey: "name",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Language",
      accessorKey: "language",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Create Date",
      accessorKey: "createdAt",
      enableColumnFilter: false,
      enableSorting: true,
      cell: cellProps => {
        return moment(cellProps.row.original.createdAt)
          .utc()
          .format("YYYY-MM-DD HH:mm")
      },
    },
    {
      header: "Create By",
      accessorKey: "createdBy",
      enableColumnFilter: false,
      enableSorting: false,
    },

    {
      header: "Tools",
      accessorKey: "user_id",
      enableColumnFilter: false,
      enableSorting: false,
      cell: cellProps => {
        let _interviewId = cellProps.row.original.id
        const disabledDialog =
          cellProps.row.original.statusDialog == "success" ? false : true
        const disabledSummary =
          cellProps.row.original.statusSummary == "success" ? false : true
        return (
          <>
            {checkScope("interviewDialog:create") && (
              <MyTooltip label="Export Evaluate">
                <DownLoadFile
                  colorBox="btn-primary"
                  disabled={disabledDialog}
                  interviewId={_interviewId}
                  exportType="evaluate"
                />
              </MyTooltip>
            )}
            &nbsp;
            {checkScope("interviewDialog:create") && (
              <MyTooltip label="Export Summary">
                <DownLoadFile
                  disabled={disabledSummary}
                  interviewId={_interviewId}
                  exportType="summary"
                />
              </MyTooltip>
            )}
            &nbsp;
            {checkScope("interviewDialog:create") && (
              <MyTooltip label="Edit">
                <Link
                  className={`btn btn-warning`}
                  title={`Edit`}
                  to={`/interviewDialog/edit/${cellProps.row.original.id}`}
                >
                  <i className={`bx bx-edit-alt`}></i>
                </Link>
              </MyTooltip>
            )}
            &nbsp;
            {checkScope("interviewDialog:create") && (
              <MyTooltip label="Delete">
                <Link
                  className={`btn btn-danger`}
                  title={`Delete`}
                  onClick={deleteRow(_interviewId)}
                >
                  <i className={`bx bx-trash`}></i>
                </Link>
              </MyTooltip>
            )}
            &nbsp;
          </>
        )
      },
    },
  ])

  const [contentList, setContentList] = useState([])
  const [contentListLoading, setContentListLoading] = useState(false)

  useEffect(() => {
    const numRows = 10 //
    for (let index = 0; index < numRows; index++) {
      const targetId = `tooltip-btn-${index}`
      const element = document.getElementById(targetId)
      if (element) {
        setTargetReady(prev => ({ ...prev, [index]: true }))
      }
    }
  }, [])

  useEffect(() => {
    setContentListLoading(true)
    const fetchContentList = async () => {
      const result = await get(
        process.env.REACT_APP_BACKEND_URL + "/v1/admin/interview-dialog"
      )

      const sortedData = result.resultData.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })

      setContentList(sortedData)
    }

    fetchContentList()
  }, [interviews])

  useEffect(() => {
    setContentListLoading(false)
  }, [contentList])

  //meta title
  document.title = "InterviewDialog | " + process.env.REACT_APP_CMS_TITLE

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={props.t("Interview Dialog")}
            breadcrumbItems={[
              { title: "Interview Dialog", link: "interviewDialog" },
              { title: "List ", link: "list" },
            ]}
          />

          <div className="bInnerContent">
            {contentListLoading ? (
              <Spinners setLoading={setContentListLoading} />
            ) : (
              <TableContainer
                isAddButton={true}
                addRowLink={`/create`}
                columns={columns}
                data={contentList || []}
                isGlobalFilter={true}
                isPagination={true}
                SearchPlaceholder="Search"
                pagination="pagination"
                paginationWrapper="dataTables_paginate paging_simple_numbers"
                tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                rootMenu="interviewDialog"
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

InterviewList.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(InterviewList)
